var REQUEST_ID_HEADER = "x-lemonade-request-id";

export { REQUEST_ID_HEADER };
